import { useMemo as n, createElement as m } from "react";
import { I18nContext as i } from "./help-center-knowledge-anatomies40.js";
function u({
  i18n: e,
  defaultNS: r,
  children: o
}) {
  const t = n(() => ({
    i18n: e,
    defaultNS: r
  }), [e, r]);
  return m(i.Provider, {
    value: t
  }, o);
}
export {
  u as I18nextProvider
};
//# sourceMappingURL=help-center-knowledge-anatomies13.js.map
